import classNames from 'classnames';
import _get from 'lodash.get';
import { Button, Grid, Paper, Typography, withStyles } from 'material-ui';
import CheckIcon from 'material-ui-icons/Check';
import { LinearProgress } from 'material-ui/Progress';
import React from 'react';
import { translate } from 'react-i18next';
import InformationPanel from '../../ui/InformationPanel';
import OLYWebPageComponent from '../OLYWebPageComponent';
import DynIcon from '../Utils/DynIcon';
import { getReservationById, sendMail, openPDFForReservation, getPDFForReservation } from './../Reservations/reservationsServices';
import TransferDetailRender from './../Transfers/TransferDetailRender';
import ReservationFlightRender from './Flight/ReservationFlightRender';
import TinyFlightRender from './Flight/TinyFlightRender';
import HotelHeaderRender from './HotelHeaderRender';
import ReservationCancelDetailsRender from './ReservationCancelDetailsRender';
import ReservationDetailsRender from './ReservationDetailsRender';
import ReservationHolderRender from './ReservationHolderRender';
import ReservationObservationsRender from './ReservationObservationsRender';
import ReservationPricesRender from './ReservationPricesRender';
import ReservationTermsRender from './ReservationTermsRender';
import ReservationBigButton from './ReservationBigButton';
import SendMailDialog from '../../ui/SendMailDialog';
import { connect } from 'react-redux';
import { HourglassEmpty } from 'material-ui-icons';

const styles = theme => ({
    onReservationSuccessMessageBox: {
        fontSize: '1.2em',
        fontWeight: 400,
        color: theme.palette.primary.contrastText,
    },
    locatorTitle: {
        color: theme.palette.primary.contrastText,
        fontSize: '16px',
        fontWeight: 300,
    },
    expansionPanelFilter: {
        backgroundColor: theme.palette.primary.main,
        padding: 0,
    },
    onRequestIcon: {
        color: theme.palette.primary.contrastText,
        transform: 'scale(1.2)',
        float: 'left',
        marginRight: '12px',
        marginTop: '4px'
    },
    success: {
        backgroundColor: theme.palette.background.success
    },
    fail: {
        backgroundColor: theme.palette.background.error
    },
    tabHeaderButtonContainer: {
        width: 'auto',
        borderRadius: 0,
        /* backgroundColor: '#3155A1', */
        backgroundColor: 'var(--primary-color)',
        display: 'inline'
    },
    tabHeaderButton: {
        color: '#FFFFFF',
        /* backgroundColor: '#3155A1', */
        backgroundColor: 'var(--primary-color)',
        borderRadius: 0,
        marginRight: '10px',
        '&:hover': {
            backgroundColor: 'var(--primary-color)',
        }
    },
    tabHeaderButtonUnselected: {
        color: '#FFFFFF',
        /* backgroundColor: '#3155A1', */
        backgroundColor: 'var(--primary-color-alpha)',
        borderRadius: 0,
        marginRight: '10px',
        '&:hover': {
            backgroundColor: 'var(--primary-color)',
        }
    },
    dynamicActions: {
        backgroundColor: 'var(--primary-color)',
        display: 'flex',
        justifyContent: 'space-between',
    },
    rigthButtons: {
        marginRight: '2px',
        color: 'var(--primary-text-color)',
        '&:disabled': {
            backgroundColor: '#f5f5f52e'
        }
    },
    leftButtons: {
        color: '#FFFFFF',
        backgroundColor: '#858283',
        marginRight: '2px',
        '&:hover': {
            backgroundColor: '#585656',
        },
        '&:disabled': {
            backgroundColor: '#f5f5f52e',
            boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)'
        }
    },
    leftButtonsFake: {
        color: '#FFFFFF',
        backgroundColor: 'transparent',
        marginRight: '2px',
        '&:disabled': {
            backgroundColor: 'transparent',
        }
    }
});
/**
 * Componente que lista mis reservas
 */
class ReservationView extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.pageName = 'ReservationView';
        this.pageReference =
            'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/621740086/UI+-+Detalle+de+Reserva';

        let idReserva = '';
        if (_get(this.props, 'match.params.requestCode')) {
            //tengo que pedir el objeto RESERVA al API
            idReserva = this.props.match.params.requestCode;
        }
        this.state = {
            idReserva: idReserva,
            loading: true,
            reservation: null,
            activeReservation: null,
            associatedReservations: null,
            isNew: false,
            isUpd: false,
            bonoDialogOpen: false,
            proformaDialogOpen: false,
            observationsChecks: [
                { value: 2, checked: false, label: 'CONFIRM_BOOKING.DOBLE_BED' },
                { value: 3, checked: false, label: 'CONFIRM_BOOKING.TWO_BEDS' },
                { value: 4, checked: false, label: 'CONFIRM_BOOKING.TOP_FLOOR' },
                { value: 5, checked: false, label: 'CONFIRM_BOOKING.GROUND_FLOOR' },
                { value: 6, checked: false, label: 'CONFIRM_BOOKING.CLIENT_WHITOUT_VOUCHER' },
                { value: 7, checked: false, label: 'CONFIRM_BOOKING.LATE_ARRIVAL' },
                { value: 10, checked: false, label: 'CONFIRM_BOOKING.COT' },
                { value: 8, checked: false, label: 'CONFIRM_BOOKING.ADJOINING_ROOMS' },
                { value: 9, checked: false, label: 'CONFIRM_BOOKING.INTERCONNECTING_ROOMS' }
            ]
        };

    }

    UNSAFE_componentWillReceiveProps(params) {
    }

    componentDidMount() {
        super.componentDidMount();
        window.scrollTo(0, 0);

    }

    componentWillUnmount() {
        localStorage.removeItem('observations');
        localStorage.removeItem('updatedObservations');
        localStorage.removeItem('cancellationInsuranceAcepted');

    }

    getObservations() {
        const { clientObservation, observationsChecks } = this.state;
        const { t } = this.props;
        let observationsChecked = observationsChecks.filter(check => !!check.checked);
        let observations = [];
        if (observationsChecked && observationsChecked.length) {
            observations = observationsChecked.map(checks => (
                { id: checks.value, description: t(checks.label) }
            ));
            observations.unshift({ id: 1, description: clientObservation ? clientObservation : '' });
            return observations;
        } else {
            observations.unshift({ id: 1, description: clientObservation ? clientObservation : '' });
            return observations;
        }
    }

    pageTitleParts() {
        let parts = super.pageTitleParts();
        parts.push(this.requestCode);
        return parts;
    }

    onHashChanged = hashObject => {
        //este hash responde a /misreservas/U18X000066X02/cancelar
        this.setState({
            isUpd: this.isJustUpdated(hashObject.query),
        });
        if (hashObject && hashObject.parts && hashObject.parts.length > 1) {
            let requestCode = hashObject.parts[1];
            if (requestCode && requestCode !== 'payment-confirm' && requestCode !== 'payment-error') {
                
                this.requestCode = requestCode;
                //tengo que pedir el objeto RESERVA al API
                this.setState({ idReserva: requestCode }, () => {
                    this.handleSubmit();
                });
            }
        }
    };


    bookTransfer = (e) => {
        let reserva = this.state.reservation;
        let path = `#/search/transfers?from=${reserva.checkIn}&nights=${reserva.nights}&locator=${reserva.olympiaLocator}&adults=${reserva.totalAdults}&kidsAges=${reserva.totalKidsAges}`;
        window.open(path, '_blank');
    }

    handleSubmit = event => {
        this.setState({ loading: true });
        getReservationById(this.state.idReserva)
            .then(async (reservation) => {
                let goterror = false;
                let message = '';
                //OLYB2B-636
                let isnewposta = reservation && reservation.hasOwnProperty('fromcache') && reservation.fromcache;
                if (reservation && !reservation.hotelObservations || !reservation.hotelObservations.length) {
                    if (this.props.observations) {
                        if ((reservation && reservation.hotelObservations && !reservation.hotelObservations.length) || (reservation && !reservation.hotelObservations)) {
                            reservation.hotelObservations = this.props.observations;
                        }
                    } else {
                        reservation.hotelObservations = reservation && reservation.hotelObservations
                            && (!reservation.hotelObservations.length || !reservation.hotelObservations) &&
                            localStorage.getItem('observations') ? JSON.parse(localStorage.getItem('observations')) : [];
                    }
                }
                if (reservation && reservation.message) {
                    goterror = true;
                    message = reservation.message;
                    reservation = null;
                }

                let thestate = {
                    error: goterror,
                    message: message,
                    loading: false,
                    reservation: reservation,
                    activeReservation: reservation,
                    associatedReservations: [reservation],
                    isNew: isnewposta,
                    hasTransfer: false,
                };


                if (reservation.associatedTransfers && reservation.associatedTransfers.length > 0) {
                    thestate.associatedReservations = [reservation, ...reservation.associatedTransfers];
                    thestate.hasTransfer = reservation.associatedTransfers.length > 0;
                }

                await this.setState(thestate);
                if (this.state.reservation) {
                    this.getObservationsChecks();
                }

            })
            .catch(reason => {
                this.setState({ loading: false });
                alert(reason.message);
            });
    };

    isJustUpdated = query => query && query.upd === 'true';

    renderReservationTabs = () => {

        if (this.state && this.state.associatedReservations /*  && reservation.type === 'Hotel' */) {
            return (
                <Paper className={this.props.classes.tabHeaderButtonContainer} elevation={1}>
                    <Grid container direction="row" style={{ justifyContent: 'space-between', width: '100%', margin: '0' }}>
                        <Grid item className="cmsTabs" style={{ paddingRight: '0px' }}>
                            {this.renderTabButton(this.state.associatedReservations[0])}
                            {
                                this.state.associatedReservations.length > 1 ?
                                    this.state.associatedReservations.slice(1).map(item => {
                                        return this.renderTabButton(item);
                                    })
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Paper>
            );
        }
        else {
            return '';
        }
    }

    renderTabButton = (reservation) => {
        return (
            reservation ?
                <Button
                    component="a"
                    style={{ textTransform: 'none', padding: '6px' }}
                    className={this.state.activeReservation && this.state.activeReservation.olympiaLocator === reservation.olympiaLocator ?
                        this.props.classes.tabHeaderButton + ' cmsTab'
                        : this.props.classes.tabHeaderButtonUnselected + ' cmsTab TabUnselected'}
                    onClick={(e) => this.onTabClick(e, reservation)}>
                    <ReservationBigButton reservation={reservation} t={this.props.t} />
                </Button>
                : ''
        );
    }

    onTabClick = (event, reservation) => {
        if (event.ctrlKey) {
            window.open('/#/bookings/' + reservation.olympiaLocator + '/view');
        }
        this.setState({ reservation: reservation, activeReservation: reservation });
    }

    isHotel = (reservation) => {
        return reservation.type === 'Hotel';
    }
    hasTransfer = (reservation) => {
        return reservation.associatedTransfers.length !== 0;
    }

    renderHotelHeaderAndDetails = (reservation) => {
        if (reservation && reservation.type === 'Hotel') {
            return (
                <HotelHeaderRender hotel={reservation.hotel} />
            );
        }
        else {
            return '';
        }
    }

    renderTranferDetails = (reservation) => {
        if (reservation && reservation.type === 'DirectionsBus') {
            return (
                <TransferDetailRender
                    currentUser={this.currentUser}
                    transfer={reservation.transfer}
                    viewOnlyMode={true}
                />
            );
        }
        else {
            return '';
        }

    }

    saveProformaPdf = () => {
        openPDFForReservation(this, this.state.activeReservation.olympiaLocator, 'proforma');
    }

    saveBonoPdf = () => {
        openPDFForReservation(this, this.state.activeReservation.olympiaLocator, 'bono');
    }

    /** SEND MAIL API */
    getEmailFrom = () => this.state.reservation ? this.state.reservation.agency.email : '';

    openBonoDialog = () => {
        this.openDialogGeneric('bono');
    };
    closeBonoDialog = () => this.setState({ bonoDialogOpen: false });

    openProformaDialog = () => {
        this.openDialogGeneric('proforma');
    };
    closeProformaDialog = () => this.setState({ proformaDialogOpen: false });

    openDialogGeneric = (type) => {
        window.scrollTo(0, 0);
        let scope = this;
        let fname = this.state.activeReservation.olympiaLocator + '_' + type + '.pdf';
        scope.setState({ loading: true });
        getPDFForReservation(this.state.activeReservation.olympiaLocator, type).then(data => {
            let obj = { loading: false };
            const blob = new Blob([data], { type: 'application/pdf' });
            let reader = new FileReader();
            reader.onload = function () {
                let dataUrl = reader.result;
                obj['attachments' + type] = [{
                    filename: fname,
                    content: dataUrl.split('base64,')[1],
                    encoding: 'base64'
                }];
                obj[type + 'DialogOpen'] = true;
                scope.setState(obj);
            };
            reader.readAsDataURL(blob);
        }).catch(e => {
            scope.setState({ loading: false });
            alert(e.message);
        });
    };

    modifyClickHandler = () => {
        const bookingId = this.state.activeReservation.olympiaLocator;
        if (this.state.activeReservation.type !== 'Hotel') {
            alert(this.props.t('COMMON.UNABLE_TO_MODIFY'));
            return;
        }

        getReservationById(bookingId).then(rs => {
            const href = '#/bookings/' + bookingId + '/modify';
            window.location.href = href;
        }).catch(e => {
            alert(e.message);
        });
    }

    cancelClickHandler = async () => {
        const bookingId = this.state.activeReservation.olympiaLocator;
        //href={'#/bookings/' + this.state.activeReservation.olympiaLocator + '/cancel'}
        try {
            const reseva = await getReservationById(bookingId);
            const href = '#/bookings/' + reseva.olympiaLocator + '/cancel';
            window.location.href = href;
        } catch (error) {
            alert(error.message);
        }
    }

    getObservationsChecks() {
        let { observationsChecks } = this.state;
        const { hotelObservations } = this.state.reservation;
        const filteredChecks = observationsChecks.map(check => {
            check.checked = !!hotelObservations.find(val => val.id === check.value);
            return check;
        });
        this.setState({ observationsChecks: filteredChecks });
    }


    render() {
        const { classes, t } = this.props;
        const reservation = this.state.reservation;
        if (reservation) {
            reservation.cancellationInsuranceAcepted = reservation.hotel && reservation.hotel.cancellationInsurance &&
                reservation.hotel.cancellationInsurance.active === 'SI';
        }
        let hasEmptyObservations = false;
        if (reservation && reservation.hotelObservations && reservation.hotelObservations.length === 1) {
            hasEmptyObservations = reservation.hotelObservations[0].description === '';
        } else if (reservation && reservation.hotelObservations && reservation.hotelObservations.length > 1) {
            hasEmptyObservations = false;
        } else {
            hasEmptyObservations = true;
        }
        return (
            <div className="cmsDetails">
                <div className="cmsContainer">
                    <div className={classes.root}>
                        {(this.state.isNew || this.state.isUpd) && !this.state.error ? (
                            <div className="cmsInfo">
                                <div className={'reservationSuccessContainer'}>
                                    <Grid
                                        container className={classNames(reservation.state === 'P' ? classes.fail : classes.success, 'InformationPanel')}>
                                        <CheckIcon className={classes.onRequestIcon} />
                                        <Typography className={classes.onReservationSuccessMessageBox}>
                                            {this.state.isNew
                                                ? (reservation.state === 'R' ?
                                                    t('CONFIRM_BOOKING.CONFIRM_SUCCESS_MESSAGE') : t('CONFIRM_BOOKING.CONFIRM_PENDING_MESSAGE'))
                                                : t('CONFIRM_MODIFY_BOOKING.CONFIRM_SUCCESS_MESSAGE')}
                                        </Typography>
                                    </Grid>
                                </div>
                                {reservation.type === 'Hotel' && this.currentUser.authorities.includes('B2BTraslados') ?
                                    <Paper className={classes.root} elevation={1} style={{ marginBottom: '10px', height: '72px' }}>
                                        <Grid container direction="row" justify="space-between" alignItems="center">
                                            <Grid item>
                                                <img src="/assets/viano.png" style={{ maxHeight: '72px' }} alt="Transfer Icon" />
                                            </Grid>
                                            <Grid item>
                                                <Typography>{t('TRANSFERS.BOOK_NEW_TRANSFER')}</Typography>
                                            </Grid>
                                            <Grid item xs></Grid>
                                            <Grid item style={{ marginRight: '6px' }}>
                                                <Button className="button"
                                                    variant="raised"
                                                    color={'primary'}
                                                    component="a"
                                                    onClick={this.bookTransfer}
                                                    disabled={this.state.loading}>
                                                    <DynIcon icon='DirectionsBus' style={{ color: 'white' }} />
                                                    {t('TRANSFERS.BOOK_BUTTON')}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                    :
                                    ''
                                }
                            </div>
                        ) : ''}
                        {
                            this.state.loading && this.state.idReserva !== 'payment-confirm' && this.state.idReserva !== 'payment-error' ? (
                                <div>
                                    <div className="cmsContainer">
                                        {t('BOOKING_DETAIL.ACCESSING_BOOKING_DETAIL') + ' ' + this.state.idReserva}
                                        <LinearProgress className="cmsProgressBar" />
                                    </div>
                                </div>
                            ) : ''
                        }
                        {this.state.error ? (
                            <InformationPanel
                                type="error"
                                title={this.props.t('BOOKING_DETAIL.QUERY_ERROR')}
                                text={this.state.message}
                            />
                        ) : ''}
                        <div className="cmsStatus">
                            {this.renderReservationTabs(reservation)}
                            {this.state.activeReservation ?
                                <div className={classes.dynamicActions}>
                                    <div>
                                        <span>{t('BOOKING_DETAIL.VOUCHER')}</span>
                                        <Button variant="raised"
                                            className={classes.leftButtons}
                                            onClick={this.saveBonoPdf}
                                            disabled={!this.state.activeReservation.allowedActions.includes('BONO')}>
                                            <DynIcon icon="Print" style={{ color: 'white' }} />
                                            {t('COMMON.PRINT')}
                                        </Button>
                                        <Button variant="raised"
                                            className={classes.leftButtons}
                                            onClick={this.openBonoDialog}
                                            disabled={!this.state.activeReservation.allowedActions.includes('BONO')}>
                                            <DynIcon icon="Mail" style={{ color: 'white' }} />
                                            {t('COMMON.SEND')}
                                        </Button>
                                        <span>{t('BOOKING_DETAIL.PROFORMA')}</span>
                                        <Button variant="raised"
                                            className={classes.leftButtons}
                                            onClick={this.saveProformaPdf}
                                            disabled={!this.state.activeReservation.allowedActions.includes('PROFORMA')}>
                                            <DynIcon icon="Print" style={{ color: 'white' }} />
                                            {t('COMMON.PRINT')}
                                        </Button>
                                        <Button variant="raised"
                                            className={classes.leftButtons}
                                            onClick={this.openProformaDialog}
                                            disabled={!this.state.activeReservation.allowedActions.includes('PROFORMA')}>
                                            <DynIcon icon="Mail" style={{ color: 'white' }} />
                                            {t('COMMON.SEND')}
                                        </Button>
                                    </div>

                                    <div>
                                        {this.state.activeReservation.type === 'Hotel' && this.state.activeReservation.allowedActions.includes('ADD_TRANSFER') ?
                                            <Button component="a"
                                                variant="raised"
                                                className={classes.rigthButtons}
                                                style={{ backgroundColor: '#008000' }}
                                                color="primary"
                                                target="_blank"
                                                href={`#/search/transfers?from=${this.state.activeReservation.checkIn}&nights=${this.state.activeReservation.nights}&locator=${this.state.activeReservation.olympiaLocator}&adults=${this.state.activeReservation.totalAdults}&kidsAges=${this.state.activeReservation.totalKidsAges}`}>
                                                <DynIcon icon="DirectionsBus" style={{ color: 'white' }} />
                                                {this.props.t('BOOKING_DETAIL.ADD_TRANSFER_BOOKING_BUTTON')}
                                            </Button> : ''
                                        }
                                        <Button variant="raised"
                                            disabled={!this.state.activeReservation.allowedActions.includes('MODIFY')}
                                            onClick={this.modifyClickHandler}
                                            className={classes.rigthButtons}
                                            color="primary">
                                            <DynIcon icon="Edit" style={{ color: 'white' }} />
                                            {this.props.t('BOOKING_DETAIL.MODIFY_BOOKING_BUTTON')}
                                        </Button>
                                        <Button variant="raised"
                                            color="secondary"
                                            className={classes.rigthButtons}
                                            onClick={this.cancelClickHandler}
                                            style={{ opacity: this.state.activeReservation.allowedActions.includes('CANCEL') ? 1 : 0.25 }}
                                            disabled={!this.state.activeReservation.allowedActions.includes('CANCEL')}>
                                            <DynIcon icon="Cancel" style={{ color: 'white' }} />
                                            {this.props.t('COMMON.CANCEL')}
                                        </Button>
                                    </div>
                                </div>
                                : ''}
                        </div>
                        <table width="100%" cellPadding="0" cellSpacing="0" className="ReservationViewTableContainer">
                            <tr>
                                <td width="50%" valign="top">
                                    {this.renderHotelHeaderAndDetails(reservation)}
                                    {this.renderTranferDetails(reservation)}
                                </td>
                                <td width="50%" valign="top" className="cmsReservationData">
                                    {reservation && reservation.type === 'Hotel' ?
                                        <ReservationDetailsRender reservation={reservation} cancellationInsurance={reservation.hotel.cancellationInsurance} /> : ''
                                    }
                                    <ReservationPricesRender
                                        reservation={reservation}
                                        cancellationInsurance={reservation && reservation.hotel && reservation.hotel.cancellationInsurance ? reservation.hotel.cancellationInsurance : null}
                                        isNew={this.state.isNew}
                                        onlyShowPVP={true}
                                        displayToolTip={this.accountName == 'b2bweberoski'}
                                        onlyShowSalesPrice={reservation && reservation.type === 'DirectionsBus' ? true : false}
                                    />
                                    <ReservationHolderRender reservation={reservation} viewOnlyMode={true} />
                                    {
                                        reservation && reservation.flightDataRequired ?
                                            <ReservationFlightRender
                                                reservation={reservation}
                                                flighError={this.state.florFlightError}
                                                setOutboundFlight={(value) => {
                                                    /*  this.setOutboundFlight(value); */
                                                }}
                                                setReturnFlight={(value) => {
                                                    /* this.setReturnFlight(value); */
                                                }}
                                                showButtons={true}
                                            />
                                            : ''
                                    }
                                    {this.state.activeReservation && this.state.activeReservation.transfer
                                        && this.state.activeReservation.transfer.flightinformation && this.state.activeReservation.transfer.flightinformation.airport !== '' ?
                                        <div className="cmsFlight">
                                            <TinyFlightRender
                                                viewOnlyMode={true}
                                                flightinformation={this.state.activeReservation.transfer.flightinformation}
                                            >
                                            </TinyFlightRender>
                                            {/* <TinyFlightRender 
                                        flightinformation={reservation.transfer.flights[1]}
                                        type="TO"
                                    >
                                    </TinyFlightRender> */}
                                        </div>
                                        : ''
                                    }
                                    { !hasEmptyObservations &&
                                        <ReservationObservationsRender
                                            reservation={reservation}
                                            checks={this.state.observationsChecks}
                                            isNew={this.state.isNew}
                                        />
                                    }
                                    {reservation && reservation.importantNotes && 
                                    <ReservationTermsRender reservation={reservation} isNew={this.state.isNew} />
                                    }
                                    <ReservationCancelDetailsRender reservation={reservation} viewOnlyMode={true} />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <SendMailDialog
                        open={this.state.bonoDialogOpen}
                        onClose={this.closeBonoDialog}
                        getEmailFrom={this.getEmailFrom}
                        sendMail={sendMail}
                        attachments={this.state.attachmentsbono}
                    />

                    <SendMailDialog
                        open={this.state.proformaDialogOpen}
                        onClose={this.closeProformaDialog}
                        getEmailFrom={this.getEmailFrom}
                        sendMail={sendMail}
                        attachments={this.state.attachmentsproforma}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        observations: state.hotelsRedux.observations
    };
};

export default connect(mapStateToProps)(translate('translations')(withStyles(styles)(ReservationView)));


// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationView.js